let audioContext = null;
let unlockListenersInstalled = false;

function audioContextConstructor() {
  return window.AudioContext || window.webkitAudioContext;
}

export function getAudioContext() {
  if (typeof window === 'undefined') {
    return null;
  }

  if (audioContext && audioContext.state !== 'closed') {
    return audioContext;
  }

  const AudioContext = audioContextConstructor();

  if (!AudioContext) {
    return null;
  }

  audioContext = new AudioContext();

  return audioContext;
}

export function unlockAudioContext() {
  const context = getAudioContext();

  if (!context) {
    return;
  }

  if (context.state === 'suspended') {
    context.resume().catch(() => {});
  }

  const oscillator = context.createOscillator();
  const gain = context.createGain();
  const now = context.currentTime;

  gain.gain.setValueAtTime(0.0001, now);
  oscillator.frequency.setValueAtTime(440, now);
  oscillator.connect(gain);
  gain.connect(context.destination);
  oscillator.start(now);
  oscillator.stop(now + 0.01);
  oscillator.onended = () => {
    oscillator.disconnect();
    gain.disconnect();
  };
}

export function installAudioUnlockListeners() {
  if (unlockListenersInstalled || typeof window === 'undefined') {
    return;
  }

  unlockListenersInstalled = true;

  ['pointerdown', 'touchstart', 'keydown', 'click'].forEach((eventName) => {
    window.addEventListener(eventName, unlockAudioContext, {
      capture: true,
      passive: true,
    });
  });
}

export function playTone({
  attack = 0.01,
  duration = 0.16,
  frequency = 880,
  type = 'sine',
  volume = 0.22,
} = {}) {
  const context = getAudioContext();

  if (!context) {
    return;
  }

  if (context.state === 'suspended') {
    context.resume().catch(() => {});
  }

  const oscillator = context.createOscillator();
  const gain = context.createGain();
  const now = context.currentTime;

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, now);
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(volume, now + attack);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);

  oscillator.connect(gain);
  gain.connect(context.destination);
  oscillator.start(now);
  oscillator.stop(now + duration + 0.02);
  oscillator.onended = () => {
    oscillator.disconnect();
    gain.disconnect();
  };
}
